import React from 'react';
import { Instagram, Facebook, Twitter, Youtube, Mail, Phone, MapPin } from 'lucide-react';
import { Button } from "./ui/button.jsx";
import { Separator } from "./ui/separator.jsx";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">


          {/* Kolom 1: Brand & Deskripsi */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img
                src="https://kontentutorialmpstore-cdn.maduraprime.com/5a467318-6398-432a-bbce-60cba851785c.png"
                alt="MPStore Logo"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
              Platform SuperApps UMKM terdepan yang membantu digitalisasi usaha Anda dengan berbagai fitur canggih dan mudah digunakan.
            </p>
            <div className="flex space-x-4 pt-2">
              <a href="https://instagram.com/mpstore_superappumkm" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-pink-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://facebook.com/people/MPStore/100087175355298/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-blue-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-600 transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Kolom 2: Layanan */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-4">Layanan</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors">Aplikasi Kasir</a></li>
              <li><a href="#" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors">PPOB & Pulsa</a></li>
              <li><a href="#" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors">QRIS Pembayaran</a></li>
              <li><a href="#" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors">Manajemen Stok</a></li>
              <li><a href="#" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors">Laporan Keuangan</a></li>
            </ul>
          </div>

          {/* Kolom 3: Dukungan */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-4">Dukungan</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors">Pusat Bantuan</a></li>
              <li><a href="#" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors">Syarat & Ketentuan</a></li>
              <li><a href="#" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors">Kebijakan Privasi</a></li>
              <li><a href="#" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors">Blog & Berita</a></li>
              <li><a href="#" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 text-sm transition-colors">Karir</a></li>
            </ul>
          </div>

          {/* Kolom 4: Kontak */}
          <div>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-4">Hubungi Kami</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-gray-600 dark:text-gray-400">
                <MapPin className="w-5 h-5 text-blue-600 mt-0.5 shrink-0" />
                <span>Ruko Khayangan Residence Blok RA-11, Lantai 2, Jalan Halim Perdana Kusuma, Bangkalan 69119, Jawa Timur</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400">
                <Phone className="w-5 h-5 text-blue-600 shrink-0" />
                <span>+62 819-9898-3991</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400">
                <Mail className="w-5 h-5 text-blue-600 shrink-0" />
                <span>hello@mpstore.co.id</span>
              </li>
            </ul>
            <div className="mt-6">
              <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                Download Aplikasi
              </Button>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-gray-200 dark:bg-gray-700" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center md:text-left">
            &copy; {currentYear} MPStore Training Center. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500 dark:text-gray-400">
            <a href="#" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;